import React from "react";

import { Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import bgVideo from "../../../assets/bg_video.mp4";

import "./event_home.css";

const EventHome = () => {
    return (
        <section id="event_home_section">
            <video
                id="event_home_bg_video"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                aria-hidden="true"
            >
                <source src={bgVideo} type="video/mp4" />
            </video>
            <div id="event_home_txt_div">
                <h5 id="event_home_sbhdng" className="event_home_reveal event_home_reveal_delay_1">
                    Creating Opportunities In PropTech With
                </h5>
                <h1 id="event_home_hdng" className="event_home_reveal event_home_reveal_delay_2">
                    <span className="event_home_hdng_prefix">THE</span>
                    <span className="event_home_hdng_brand">PROPTECH CLUB</span>
                </h1>

                <p id="event_home_txt" className="event_home_reveal event_home_reveal_delay_3">
                    Your Gateway to Innovation, Education, and Collaboration in PropTech
                </p>

                <div id="event_home_buttons_div" className="event_home_reveal event_home_reveal_delay_4">
                    <Link id="event_home_learn_btn" className="event_home_cta_link" to="/membership">
                        Become A Member
                        <MdKeyboardArrowRight />
                    </Link>
                    <Link id="event_home_join_btn" className="event_home_cta_link" to="/proptech-club/about">
                        Explore The Ecosystem
                        <MdKeyboardArrowRight />
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default EventHome;

